/**
 * Use instead of bare `isLoading` for SSR route guards.
 * With dehydrated React Query state, `isLoading` can be true briefly while `data`
 * is already available — rendering a loading shell then breaks hydration and forces
 * React to discard SSR markup (including <img>), which reloads images.
 */
export function shouldShowQueryLoading(
  isLoading: boolean,
  data: unknown,
): boolean {
  return isLoading && data === undefined;
}
